
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5945',
  depVersions: {
  "data-privacy-request-ui": "static-1.5945",
  "client-types": "static-1.505",
  "data-fetching-client": "static-1.10068",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8459",
  "hub-http-shared-msw-handlers": "static-1.10814",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11912",
  "I18n": "static-7.1694",
  "jasmine-runner": "static-1.6870",
  "quartz": "static-1.7595",
  "react-dlb": "static-1.92",
  "rpc-client-utils": "static-1.5090",
  "ui-components-test-utils": "static-1.6049",
  "UIComponents": "static-3.8858",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.98",
  "foundations-assets": "static-1.5306",
  "foundations-components": "static-1.8665",
  "foundations-components-test-utils": "static-1.6148",
  "foundations-theming": "static-1.4903",
  "hub-http": "static-1.6630",
  "hubspot-url-utils": "static-1.4383",
  "quartz-config": "static-1.1373",
  "quartz-core": "static-1.6814",
  "quartz-routing": "static-1.1025",
  "quick-fetch": "static-1.4196",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-rhumb": "static-1.17154",
  "SharedI18nStrings": "static-1.186",
  "ui-addon-i18n": "static-1.11567",
  "usage-tracker": "static-1.7735",
  "usage-tracker-anonymous": "static-1.6152",
  "usage-tracker-core": "static-1.7585",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3872",
  "quartz-webpack": "static-1.3819",
  "bend-plugin-quartz-routing": "static-1.673",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.92",
  "HeadJS": "static-2.813",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3570",
  "msw": "static-1.102",
  "msw-config": "static-1.21",
  "testing-library": "static-1.163",
  "ts-schema": "static-1.4366",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "react-utils": "static-2.5628",
  "StyleGuideUI": "static-3.513",
  "jasmine": "static-4.4729",
  "bend-plugin-chirp-manifest": "static-1.500",
  "chirp-fetch": "static-1.2322",
  "HubStyle": "static-2.12219",
  "ui-addon-draggable": "static-3.5168",
  "cssUtils": "static-1.1042",
  "hs-story-utils": "static-1.9846",
  "icons": "static-2.699",
  "react-create-root-preference": "static-1.92",
  "react-select-plus": "static-1.117",
  "react-virtualized": "static-2.111",
  "ui-images": "static-2.1269",
  "bend-plugin-foundations-components": "static-1.4934",
  "floating-ui": "static-1.67",
  "foundations-theming-specialty": "static-1.2619",
  "react-aria": "static-1.76",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.2964",
  "ui-fonts": "static-1.1174",
  "foundations-components-legacy": "static-1.1690",
  "bend-plugin-foundations-theming": "static-1.3386",
  "foundations-theming-base": "static-1.3888",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.366",
  "opentelemetry-fe-types": "static-1-aeastham-default-document-load-user-interaction.5",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.898",
  "hubspotter-http": "static-1.4933",
  "mobile-manifest-mixins": "static-1.596",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1-aeastham-default-document-load-user-interaction.5",
  "quartz-auth": "static-1.1270",
  "quartz-head": "static-1.1260",
  "quartz-i18n": "static-1.1270",
  "quartz-test": "static-1.1270",
  "quartz-tracking": "static-1.974",
  "trellis-components": "static-1.2983",
  "usage-tracker-container": "static-1.7725",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3518",
  "opentelemetry-web": "static-1.20",
  "beacon-keepalive-queue": "static-1.121",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.82",
  "sassPrefix": "static-1.309",
  "stylex-utils": "static-1.162",
  "trellis-theming": "static-1.1405",
  "hubspotter-http-shared-msw-handlers": "static-1.10812",
  "usage-tracker-session-replay": "static-1.5421",
  "base-ui": "static-1.26",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5945",
  "client-types": "/client-types/static-1.505",
  "data-fetching-client": "/data-fetching-client/static-1.10068",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8459",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10814",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11912",
  "I18n": "/I18n/static-7.1694",
  "jasmine-runner": "/jasmine-runner/static-1.6870",
  "quartz": "/quartz/static-1.7595",
  "react-dlb": "/react-dlb/static-1.92",
  "rpc-client-utils": "/rpc-client-utils/static-1.5090",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6049",
  "UIComponents": "/UIComponents/static-3.8858",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
  "foundations-assets": "/foundations-assets/static-1.5306",
  "foundations-components": "/foundations-components/static-1.8665",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6148",
  "foundations-theming": "/foundations-theming/static-1.4903",
  "hub-http": "/hub-http/static-1.6630",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "quartz-config": "/quartz-config/static-1.1373",
  "quartz-core": "/quartz-core/static-1.6814",
  "quartz-routing": "/quartz-routing/static-1.1025",
  "quick-fetch": "/quick-fetch/static-1.4196",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-rhumb": "/react-rhumb/static-1.17154",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11567",
  "usage-tracker": "/usage-tracker/static-1.7735",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6152",
  "usage-tracker-core": "/usage-tracker-core/static-1.7585",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3872",
  "quartz-webpack": "/quartz-webpack/static-1.3819",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.673",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.92",
  "HeadJS": "/HeadJS/static-2.813",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3570",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.21",
  "testing-library": "/testing-library/static-1.163",
  "ts-schema": "/ts-schema/static-1.4366",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "react-utils": "/react-utils/static-2.5628",
  "StyleGuideUI": "/StyleGuideUI/static-3.513",
  "jasmine": "/jasmine/static-4.4729",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.500",
  "chirp-fetch": "/chirp-fetch/static-1.2322",
  "HubStyle": "/HubStyle/static-2.12219",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5168",
  "cssUtils": "/cssUtils/static-1.1042",
  "hs-story-utils": "/hs-story-utils/static-1.9846",
  "icons": "/icons/static-2.699",
  "react-create-root-preference": "/react-create-root-preference/static-1.92",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-virtualized": "/react-virtualized/static-2.111",
  "ui-images": "/ui-images/static-2.1269",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4934",
  "floating-ui": "/floating-ui/static-1.67",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2619",
  "react-aria": "/react-aria/static-1.76",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.2964",
  "ui-fonts": "/ui-fonts/static-1.1174",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1690",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3386",
  "foundations-theming-base": "/foundations-theming-base/static-1.3888",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.366",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1-aeastham-default-document-load-user-interaction.5",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.898",
  "hubspotter-http": "/hubspotter-http/static-1.4933",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.596",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1-aeastham-default-document-load-user-interaction.5",
  "quartz-auth": "/quartz-auth/static-1.1270",
  "quartz-head": "/quartz-head/static-1.1260",
  "quartz-i18n": "/quartz-i18n/static-1.1270",
  "quartz-test": "/quartz-test/static-1.1270",
  "quartz-tracking": "/quartz-tracking/static-1.974",
  "trellis-components": "/trellis-components/static-1.2983",
  "usage-tracker-container": "/usage-tracker-container/static-1.7725",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "opentelemetry-web": "/opentelemetry-web/static-1.20",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.121",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.82",
  "sassPrefix": "/sassPrefix/static-1.309",
  "stylex-utils": "/stylex-utils/static-1.162",
  "trellis-theming": "/trellis-theming/static-1.1405",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10812",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5421",
  "base-ui": "/base-ui/static-1.26",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
